import React from "react";
import { Col } from "antd";
import styles from "./searchGroup.scss";
import SearchControl from "../SearchControl";

const antDesignLayoutMaxSpans = 24;
const getWebSpan = config =>
  config.column
    ? antDesignLayoutMaxSpans * config.column
    : antDesignLayoutMaxSpans;

const SearchGroup = ({
  groupConfig,
  form,
  onSubmit,
  isMobile,
  showAllSearch,
  getPopupContainer,
  hideName
}) => {
  if (!groupConfig || groupConfig.length === 0) return null;

  return (
    <Col
      className={!isMobile ? styles.group : styles.groupMobile}
      style={{ paddingBottom: `${!showAllSearch ? 0 : ""}` }}
      xs={24}
      md={getWebSpan(groupConfig)}
    >
      {!hideName && groupConfig.name ? (
        <div className={styles.groupName}>{groupConfig.name}</div>
      ) : null}
      {groupConfig.controls.map((controlConfig, index) => {

        return <SearchControl
          /* eslint-disable-next-line react/no-array-index-key */
          key={index}
          form={form}
          controlConfig={controlConfig}
          isMobile={isMobile}
          onSubmit={onSubmit}
          isSearch={true}
          isColumn={true}
          showAllControls={isMobile && true}
          searchPage={true}
          getPopupContainer={getPopupContainer}
        />
      }
      )}
    </Col>
  );
};

export default SearchGroup;



// WEBPACK FOOTER //
// ./src/components/SearchControls/SearchGroups/SearchGroup/index.tsx